import { Component } from '@angular/core'

@Component({
  selector: 'efp-steps-modal-footer',
  templateUrl: './steps-modal-footer.component.html',
})
export class StepsModalFooterComponent {}
